import springCenfApi from '../../services/springCenfApi'

export const getWarehouses = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/warehouses', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getWarehouse = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/warehouses/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeWarehouse = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/warehouses', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateWarehouse = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/warehouses/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteWarehouse = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/warehouses/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)